import { Component, Input } from '@angular/core';
import { OrderItem } from '../../models/order-item.model';

@Component({
  selector: 'app-order-table',
  templateUrl: './order-table.component.html',
  styleUrls: ['./order-table.component.scss']
})
export class OrderTableComponent {
  @Input() items: OrderItem[];
  @Input() orderid: string;
  displayedColumns = ['line', 'notes', 'quantity', 'productDescription', 'publishDates', 'actions' ];
  constructor() { }

}
